const config = {
  env: 'local',
  // apiUrl:'https://api.divinevayu.com/api/',
  // constantsRouteUrl :'https://api.divinevayu.com'
  // apiUrl:'http://192.168.0.56:5300/api/',
  // constantsRouteUrl:'https://api.kundlimarg.com'
  // apiUrl:'http://192.168.0.118:5000/api/',
  // constantsRouteUrl:'http://192.168.0.118:5000',
  apiUrl:'https://api.kundlimarg.com/api/',
  constantsRouteUrl:'https://api.kundlimarg.com',
}

export default config;